import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

/* ✅ STEP 2 ADD */
import { loadContactNumbers } from "./components/contactService";

/* ✅ SCROLL FIX */
import ScrollToTop from "./components/ScrollToTop";
import SexToysFAQIndia from "./components/SexToysFAQIndia";
// COMMON COMPONENTS
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

// HOME SECTIONS
import WelcomePage from "./components/WelcomePage";
import CategorySlider from "./components/CategorySlider";
import BestSellingSection from "./components/BestSellingSection";
import ReviewSlider from "./components/ReviewSlider";
import FeaturesSection from "./components/FeaturesSection";
import BlogPage from "./components/BlogPage";

// PAGES
import AboutPage from "./components/Pages/AboutPage";
import ForMen from "./components/Pages/ForMen";
import ForWomen from "./components/Pages/ForWomen";
import ForCouples from "./components/Pages/ForCouples";
import ProductDetail from "./components/Pages/ProductDetail";
import Contact from "./components/Contact";

// FOOTER LEGAL PAGES
import PrivacyPolicy from "./components/FooterPages/PrivacyPolicy";
import TermsConditions from "./components/FooterPages/TermsConditions";
import RefundPolicy from "./components/FooterPages/RefundPolicy";
import DiscreetDelivery from "./components/FooterPages/DiscreetDelivery";
import Blog from "./components/FooterPages/blog";

// STATE PAGES
import DelhiNCR from "./components/FooterPages/StatePages/Delhi/DelhiNCR";
import DelhiNCRSEO from "./components/FooterPages/StatePages/Delhi/DelhiNCRSEO";

import Gujarat from "./components/FooterPages/StatePages/Gujarat/Gujarat";
import GujaratSEO from "./components/FooterPages/StatePages/Gujarat/GujaratSEO";

import MaharashtraSEO from "./components/FooterPages/StatePages/Maharashtra/MaharashtraSEO";
import Maharashtra from "./components/FooterPages/StatePages/Maharashtra/Maharashtra";

import Karnataka from "./components/FooterPages/StatePages/Karnataka/Karnataka";
import KarnatakaSEO from "./components/FooterPages/StatePages/Karnataka/KarnatakaSEO";

import MadhyaPradesh from "./components/FooterPages/StatePages/MadhyaPradesh/MadhyaPradesh";
import MadhyaPradeshSEO from "./components/FooterPages/StatePages/MadhyaPradesh/MadhyaPradeshSEO";

import Rajasthan from "./components/FooterPages/StatePages/Rajasthan/Rajasthan";
import RajasthanSEO from "./components/FooterPages/StatePages/Rajasthan/RajasthanSEO";

import TamilNadu from "./components/FooterPages/StatePages/TamilNadu/TamilNadu";
import TamilNaduSEO from "./components/FooterPages/StatePages/TamilNadu/TamilNaduSEO";

import Telangana from "./components/FooterPages/StatePages/Telangana/Telangana";
import TelanganaSEO from "./components/FooterPages/StatePages/Telangana/TelanganaSEO";

import UttarPradesh from "./components/FooterPages/StatePages/UttarPradesh/UttarPradesh";
import UttarPradeshSEO from "./components/FooterPages/StatePages/UttarPradesh/UttarPradeshSEO";

import WestBengal from "./components/FooterPages/StatePages/WestBengal/WestBengal";
import WestBengalSEO from "./components/FooterPages/StatePages/WestBengal/WestBengalSEO";

// ADMIN
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ProtectedRoute from "./admin/ProtectedRoute";


import Sitemap from "./components/FooterPages/SiteMap/Sitemap";
import SexToysDelhi from "./components/FooterPages/SiteMap/SexToysDelhi";
import SexToysGujrat from "./components/FooterPages/SiteMap/SexToysGujrat";
import SexToysMaharashtra from "./components/FooterPages/SiteMap/SexToysMaharashtra";
import SexToysUttarPradesh from "./components/FooterPages/SiteMap/SexToysUttarPradesh";
import SexToysWestBengal from "./components/FooterPages/SiteMap/SexToysWestBengal";
import SexToysHaryana from "./components/FooterPages/SiteMap/SexToysHaryana";
import SexToysKarnataka from "./components/FooterPages/SiteMap/SexToysKarnataka";
import SexToysPunjab from "./components/FooterPages/SiteMap/SexToysPunjab";
import SexToysRajasthan from "./components/FooterPages/SiteMap/SexToysRajasthan";
import SexToysTamilNadu from "./components/FooterPages/SiteMap/SexToysTamilNadu";

import SexToysAndhraPradesh from "./components/FooterPages/SiteMap/SexToysAndhraPradesh";

import SexToysKerala from "./components/FooterPages/SiteMap/SexToysKerala";
import SexToysUttarakhand from "./components/FooterPages/SiteMap/SexToysUttarakhand";
import SexToysBihar from "./components/FooterPages/SiteMap/SexToysBihar";
import SexToysMadhyaPradesh from "./components/FooterPages/SiteMap/SexToysMadhyaPradesh";
// import SexToysAndhraPradesh from "./components/FooterPages/SiteMap/SexToysAndhraPradesh";
import SexToysGoa from "./components/FooterPages/SiteMap/SexToysGoa";
import SexToysHimachalPradesh from "./components/FooterPages/SiteMap/SexToysHimachalPradesh";
import SexToysJharkhand from "./components/FooterPages/SiteMap/SexToysJharkhand";
import SexToysChhattisgarh from "./components/FooterPages/SiteMap/SexToysChhattisgarh";
import SexToysOdisha from "./components/FooterPages/SiteMap/SexToysOdisha";
import SexToysTelangana from "./components/FooterPages/SiteMap/SexToysTelangana";


// AGE VERIFICATION
import AgeVerificationPopup from "./components/AgeVerificationPopup";

function AppContent() {
  const location = useLocation();

  const [showAgePopup, setShowAgePopup] = useState(false);
  const [rejected, setRejected] = useState(false);
  // const [contactLoaded, setContactLoaded] = useState(false);

  // useEffect(() => {
  //   async function initContact() {
  //     await loadContactNumbers();
  //     setContactLoaded(true);
  //   }
  //   initContact();
  // }, []);
useEffect(() => {

  loadContactNumbers();

}, []);




  useEffect(() => {
    const enabled =
      localStorage.getItem("ageVerificationEnabled") !== "false";
    const verified = localStorage.getItem("ageVerified");

    if (location.pathname === "/" && enabled && !verified) {
      const timer = setTimeout(() => {
        setRejected(false);
        setShowAgePopup(true);
      }, 8000);
      return () => clearTimeout(timer);
    } else {
      setShowAgePopup(false);
    }
  }, [location.pathname]);

  return (
    <>
      {showAgePopup && (
        <AgeVerificationPopup
          onYes={() => {
            localStorage.setItem("ageVerified", "true");
            setShowAgePopup(false);
          }}
          onNo={() => setRejected(true)}
          isRejected={rejected}
        />
      )}

    <Navbar />
<FloatingButtons />

<Routes>
        {/* HOME */}
        <Route
          path="/"
          element={
            <>
              <CategorySlider />
              <WelcomePage />
              <BestSellingSection />
              <ReviewSlider />
             <SexToysFAQIndia />
              <FeaturesSection />
              <BlogPage />
            </>
          }
        />

        {/* NORMAL PAGES */}
        <Route path="/men" element={<ForMen />} />
        <Route path="/women" element={<ForWomen />} />
        <Route path="/couples" element={<ForCouples />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<Contact />} />

        {/* FOOTER */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/discreet-delivery" element={<DiscreetDelivery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/sex-toys-in-delhi" element={<SexToysDelhi />} />
        <Route path="/sex-toys-gujarat" element={<SexToysGujrat />} />
        <Route path="/sex-toys-maharashtra" element={<SexToysMaharashtra />} />
        <Route path="/sex-toys-uttar-pradesh" element={<SexToysUttarPradesh />} />
        <Route path="/sex-toys-west-bengal" element={<SexToysWestBengal />} />
        <Route path="/sex-toys-haryana" element={<SexToysHaryana />} />
        <Route path="/sex-toys-karnataka" element={<SexToysKarnataka />} />
        <Route path="/sex-toys-punjab" element={<SexToysPunjab />} />
        <Route path="/sex-toys-rajasthan" element={<SexToysRajasthan />} />
       <Route path="/sex-toys-tamil-nadu" element={<SexToysTamilNadu />} />
       <Route path="/sex-toys-andhra-pradesh" element={<SexToysAndhraPradesh />} />
       <Route path="/sex-toys-kerala" element={<SexToysKerala />} />
       <Route path="/sex-toys-uttarakhand" element={<SexToysUttarakhand />} />
        <Route path="/sex-toys-bihar" element={<SexToysBihar />} />
        <Route path="/sex-toys-madhya-pradesh" element={<SexToysMadhyaPradesh />} />
        {/* <Route path="/sex-toys-andhra-pradesh" element={<SexToysAndhraPradesh />} /> */}
        <Route path="/sex-toys-goa" element={<SexToysGoa />} />
        <Route path="/sex-toys-himachal-pradesh" element={<SexToysHimachalPradesh />} />
        <Route path="/sex-toys-jharkhand" element={<SexToysJharkhand />} />
        <Route path="/sex-toys-chhattisgarh" element={<SexToysChhattisgarh />} />
        <Route path="/sex-toys-odisha" element={<SexToysOdisha />} />
        <Route path="/sex-toys-telangana" element={<SexToysTelangana />} />


         

        {/* SEO ROUTES */}
        <Route path="/sex-toys-delivery/delhi-ncr" element={<DelhiNCRSEO />} />
        <Route path="/sex-toys-delivery/delhi-ncr/:city" element={<DelhiNCR />} />

        <Route path="/sex-toys-delivery/gujarat" element={<GujaratSEO />} />
        <Route path="/sex-toys-delivery/gujarat/:city" element={<Gujarat />} />

        <Route path="/sex-toys-delivery/maharashtra" element={<MaharashtraSEO />} />
        <Route path="/sex-toys-delivery/maharashtra/:city" element={<Maharashtra />} />

        <Route path="/sex-toys-delivery/karnataka" element={<KarnatakaSEO />} />
        <Route path="/sex-toys-delivery/karnataka/:city" element={<Karnataka />} />

        <Route path="/sex-toys-delivery/madhya-pradesh" element={<MadhyaPradeshSEO />} />
        <Route path="/sex-toys-delivery/madhya-pradesh/:city" element={<MadhyaPradesh />} />

        <Route path="/sex-toys-delivery/rajasthan" element={<RajasthanSEO />} />
        <Route path="/sex-toys-delivery/rajasthan/:city" element={<Rajasthan />} />

        <Route path="/sex-toys-delivery/tamil-nadu" element={<TamilNaduSEO />} />
        <Route path="/sex-toys-delivery/tamil-nadu/:city" element={<TamilNadu />} />

        <Route path="/sex-toys-delivery/telangana" element={<TelanganaSEO />} />
        <Route path="/sex-toys-delivery/telangana/:city" element={<Telangana />} />

        <Route path="/sex-toys-delivery/uttar-pradesh" element={<UttarPradeshSEO />} />
        <Route path="/sex-toys-delivery/uttar-pradesh/:city" element={<UttarPradesh />} />

        <Route path="/sex-toys-delivery/west-bengal" element={<WestBengalSEO />} />
        <Route path="/sex-toys-delivery/west-bengal/:city" element={<WestBengal />} />

        {/* ADMIN */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}
